import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G6_P1_S1_Title: {
    id: `guide06.page01.slide01.title`,
  },
  G6_P1_S1_Description: {
    id: `guide06.page01.slide01.description`,
  },
  G6_P1_S2_Title: {
    id: `guide06.page01.slide02.title`,
  },
  G6_P1_S2_Description: {
    id: `guide06.page01.slide02.description`,
  },
});
